export const otherIncomeQuestions: Record<string, any> = {
  maintenance: {
    labelKey: 'applicationForm.OTHER_INCOME.hasMaintenance.label',
    booleanQuestionFormKey: 'hasMaintenance',
    explanationKey: 'applicationForm.OTHER_INCOME.hasMaintenance.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  pension: {
    labelKey: 'applicationForm.OTHER_INCOME.hasPension.label',
    booleanQuestionFormKey: 'hasPension',
    explanationKey: 'applicationForm.OTHER_INCOME.hasPension.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  rentalIncome: {
    labelKey: 'applicationForm.OTHER_INCOME.hasRentalIncome.label',
    booleanQuestionFormKey: 'hasRentalIncome',
    explanationKey: 'applicationForm.OTHER_INCOME.hasRentalIncome.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
};
